import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";
import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import { PostApi1951, PostApi1952 } from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { checkNum10 } from "../../../modules/utils/CheckLogic";
import { Container, closeLayerFn, openLayerFn } from "../../Layout";
import History from "./History";
import Input from "./Input";
import { TargetInputLayer } from "./TargetInputLayer";
import useTitle from "../../../modules/hooks/useTitle";

export default () => {
  // useTitle(
  //   activeSubmenu === 1
  //     ? "자가건강관리_검사결과_검사입력"
  //     : "자가건강관리_검사결과_검사이력"
  // );

  let dateFrom = new Date();

  const dateNow =
    dateFrom.getFullYear() +
    "" +
    checkNum10(dateFrom.getMonth() + 1) +
    "" +
    checkNum10(dateFrom.getDate());

  const [activeSubmenu, setActiveSubMenu] = useState(1);
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [targetList, setTargetList] = useState([]);
  const [reload, setReload] = useState(true);
  const [targetStudyResult, setTargetStudyResult] = useState();

  const [startDate, setStartDate] = useState(dateNow);
  const [endDate, setEndDate] = useState();

  const [checkAll, setCheckAll] = useState(false);

  const [inputTitle, setInputTitle] = useState([
    {
      name: "당화혈색소",
      code: "hba1c",
    },
    // , {
    //     'name':'총 콜레스테롤'
    //     , 'code':'chol'
    // }
    // , {
    //     'name':'HDL콜레스테롤'
    //     , 'code':'jdl'
    // }
    // , {
    //     'name':'TG중성지방'
    //     , 'code':'tg'
    // }
    // , {
    //     'name':'LDL 콜레스테롤'
    //     , 'code':'ldl'
    // }
    // , {
    //     'name':'알부민'
    //     , 'code':'albmn'
    // }
    // , {
    //     'name':'크레아틴'
    //     , 'code':'cratn'
    // }
  ]);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const onClickToSave = () => {
    let postDataArr = [];
    const postDataNameArr = [
      "hba1c",
      // "chol",
      // "jdl",
      // "tg",
      // "ldl",
      // "albmn",
      // "cratn",
    ];

    if (
      $("input[name=postData]").val() > 3 &&
      $("input[name=postData]").val() < 10
    ) {
      $("input[name=postData]").each(function () {
        if ($(this).val()) {
          postDataArr.push($(this).val());
        } else {
          postDataArr.push(0);
        }
      });

      PostApi1951(userinfo, cfg, startDate, postDataNameArr, postDataArr)
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setActiveSubMenu(2);
          }
        })
        .catch(err => {
          alert(err);
        });
    } else {
      handleAlert("", "당화혈색소는 3이상 10미만의 값을 입력하셔야 합니다.");
    }
  };

  const onClickToDelete = () => {
    let postTargetList = JSON.stringify(targetList);
    postTargetList = postTargetList.replace("[", "").replace("]", "");

    PostApi1952(userinfo, cfg, postTargetList)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setTargetList("");
          $("input[name=checkSeqNo]").prop("checked", false);
          setReload(true);
        }
      })
      .catch(err => {
        alert(err);
      });
  };

  // 삭제 대상 리스트 생성
  // type = string
  // 구분자 ','
  const settingTargetList = (targetType, data, target) => {
    if (targetType === "DELETE") {
      handleSingleCheck(target, data);
    }

    var total = $("input[name=checkSeqNo]").length;
    var checked = $("input[name=checkSeqNo]:checked").length;

    if (total != checked) {
      $("input[name=checkSeqNoAll]").prop("checked", false);
    } else {
      $("input[name=checkSeqNoAll]").prop("checked", true);
    }
  };

  const handleSingleCheck = (checked, id) => {
    if (checked) {
      // 단일 선택 시 체크된 아이템을 배열에 추가
      setTargetList(prev => [...prev, id.toString()]);
    } else {
      // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
      setTargetList(targetList.filter(el => el !== id.toString()));
    }
  };

  const settingTargetListAll = e => {
    // setTargetList();
    // console.log();
    if (e.target.checked) {
      $("input[name='checkSeqNo']").prop("checked", true);

      $("input[name=checkSeqNo]:checked").each(function (idx) {
        handleSingleCheck($(this).val(), $(this).attr("id"));
      });
    } else {
      $("input[name='checkSeqNo']").prop("checked", false);
      setTargetList("");
    }
  };

  const saveTargetInput = () => {
    closeLayerFn($(".bloodgoal-layer"));
  };

  useEffect(() => {
    setTargetList([]);
  }, [activeSubmenu]);

  return (
    <Fragment>
      <Container
        Title={"검사결과"}
        goToUrl="/sm"
        // onClick ={bottomBtnEvnet}
        color="green"
        bottom={
          activeSubmenu === 1 ? (
            <SectionBoxBtn
              onClickToSave={() => onClickToSave()}
              leftBtnTitle={"취소"}
              rightBtnTitle={"저장"}
            />
          ) : (
            targetList.length > 0 && (
              <SectionBoxBtn
                onClickToSave={() => openLayerFn($(".confirm-layer"))}
                leftBtnTitle={"선택취소"}
                rightBtnTitle={"선택삭제"}
                setTargetList={setTargetList}
              />
            )
          )
        }>
        <div className="contents sub">
          {/* 헤더 START */}
          <HeaderDiv>
            <HeaderMenuDiv
              width="50%"
              active={activeSubmenu === 1 ? "true" : "false"}
              onClick={() => {
                setActiveSubMenu(1);
                setReload(true);
                setStartDate(dateNow);
              }}>
              검사입력
            </HeaderMenuDiv>

            <HeaderMenuDiv
              width="50%"
              active={activeSubmenu === 2 ? "true" : "false"}
              onClick={() => {
                setActiveSubMenu(2);
                setReload(true);
              }}>
              검사이력
            </HeaderMenuDiv>
          </HeaderDiv>
          {/* 헤더 END */}

          {/* 검사이력 입력 & 이력 */}
          {activeSubmenu === 1 ? (
            <Input
              inputTitle={inputTitle}
              startDate={startDate}
              setStartDate={setStartDate}
              targetStudyResult={targetStudyResult}
              setTargetStudyResult={setTargetStudyResult}
            />
          ) : (
            <History
              inputTitle={inputTitle}
              targetList={targetList}
              setTargetList={settingTargetList}
              reload={reload}
              setReload={setReload}
              checkAll={checkAll}
              setCheckAll={settingTargetListAll}
              startDate={startDate}
            />
          )}
          {/* 검사이력 입력 & 이력 */}
        </div>
      </Container>
      <ConfirmLayer
        msg={"선택한 내용을 삭제하시겠습니까?"}
        handleConfirmCB={() => onClickToDelete()}
      />

      {/* 목표당화혈색소 입력 레이어 */}
      <TargetInputLayer
        onClickEvent={saveTargetInput}
        targetStudyResult={targetStudyResult}
        setTargetStudyResult={setTargetStudyResult}
      />
      {/* 목표당화혈색소 입력 레이어 */}
      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={() => closeLayerFn($(".alert-layer"))}
      />
    </Fragment>
  );
};

const HeaderDiv = styled.div`
  display: flex;
  width: 100%;
  padding-top: 32px;
`;

const HeaderMenuDiv = styled.div`
  width: ${props => props.width || "100%"};
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: ${props => (props.active === "true" ? "bold" : "200")};
  ${props =>
    props.active === "true" &&
    "text-decoration: underline 4px;text-underline-position:under;"}
`;

const SectionDiv = styled.div`
  padding-top: 32px;
  padding-left: 16px;
  padding-right: 16px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

const ListDiv = styled.div`
  padding-bottom: 16px;
  position: relative;
  display: flex;
`;

// float:left;
const NameDiv = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
`;

// float:right;
const InputData = styled.input`
  border: 1px solid #d0d0d0;
  border-radius: 7px;
  background: #fff;
  box-sizing: border-box;
  height: 40px;
  position: absolute;
  right: 0px;
  padding-right: 32px;
  padding-left: 16px;
`;

const PercentI = styled.i`
  right: 16px;
  font-size: 16px;
  color: #999;
  position: absolute;
  line-height: 40px;
`;

const SectionBoxBtn = props => {
  const { onClickToSave } = props;

  const onClickToCancel = () => {
    if (props.leftBtnTitle === "선택취소") {
      props.setTargetList("");
      $("input[name=checkSeqNo]").prop("checked", false);
    } else {
      _O.Open("/sm");
    }
  };

  return (
    <SectionDiv>
      <div
        className="two-btns-area"
        style={{ position: "relative", bottom: "100px" }}>
        <a onClick={() => onClickToCancel()}>{props.leftBtnTitle}</a>
        <a onClick={() => onClickToSave()} className="btn-aftersave">
          {props.rightBtnTitle}
        </a>
      </div>
    </SectionDiv>
  );
};
